export default __webpack_public_path__ + "static/2-396509cda5e904abd2f0ee9abaa628db.jpeg";